import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-header-title-lot-data',
  standalone: true,
  imports: [],
  templateUrl: './header-title-lot-data.component.html',
  styleUrl: './header-title-lot-data.component.scss',
})
export class HeaderTitleLotDataComponent {
  _lotNumber: string;
  _lotName: string;
  _title: string;

  @Input()
  set lotNumber(value: string) {
    this._lotNumber = value;
  }

  @Input()
  set lotName(value: string) {
    this._lotName = value;
  }

  @Input()
  set title(value: string) {
    this._title = value;
  }
}
